<template>
    <v-dialog v-model="dialogProp" width="500">
        <v-card>
            <v-toolbar flat>
                <v-spacer />
                <v-btn icon @click="dialogProp = false">
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-title>
                <h4 style="word-break: break-word;">
                    In-Patient Care (Confinement/Hospitalization):
                </h4>
            </v-card-title>
            <v-divider />

            <v-card-text>
                <ul v-for="(desc, i) in descs" :key="i">
                    <li>{{ desc }}</li>
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
    props: ['showInpatient'],

    data: () => ({
        mdiClose,
        descs: [
            'Room & Board as provided in your enrolled HMI Program.',
            'Use of Operating and/or Recovery Room.',
            'Professional Fees of HMI-affiliated physicians.',
            'Medicines, intravenous fluids, blood transfusions, and cost of attendant services.',
            'Laboratory examinations and diagnostic procedures.',
            'Dressing and casts (except fiberglass and other non-plaster types).',
            'Services and supplies related to the medical management of the patient-member.',
            'All other hospital services deemed necessary by the HMI primary care physician in the treatment of the patient.'
        ]
    }),
    computed: {
        dialogProp: {
            get() {
                return this.showInpatient
            },
            set(val) {
                this.$emit('showDialog', val)
            }
        }
    }
}
</script>

<style scoped>
ul li {
  font-size: 13px;
  padding-top: 10px;
  color: black;
  text-align: justify;
}
</style>
